module.exports = " <table> <thead> <tr> <th v-for=\"column in columns\" scope=col><span class=o-screen-reader>{{ heading }} </span>{{ column }}</th> </tr> </thead> <tbody> <tr v-for=\"row in data\"> <td v-for=\"column in columns\" scope=row :data-label=column>{{{ row[column] ? marked(row[column]) : empty }}}</td> </tr> </tbody> </table> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src-docs/app/shared/components/AppTable.vue
 ** module id = 91
 ** module chunks = 1
 **/